import PropTypes from "prop-types";

export const categoryProps = {
  SearchOccurrences: PropTypes.number,
  Documents: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.number.isRequired,
      Name: PropTypes.string,
      Occurrences: PropTypes.number,
      BackgroundColour: PropTypes.string,
      TextColour: PropTypes.string,
    }).isRequired
  ).isRequired,
  GroupName: PropTypes.string.isRequired,
  Occurrences: PropTypes.number.isRequired,
};

export const itemProps = {
  Documents: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.number.isRequired,
      Name: PropTypes.string,
      Occurrences: PropTypes.number,
      BackgroundColour: PropTypes.string,
      TextColour: PropTypes.string,
    }).isRequired
  ).isRequired,
  GroupName: PropTypes.string.isRequired,
  NounPhrase: PropTypes.string.isRequired,
  NounPhraseEscaped: PropTypes.string.isRequired,
  Occurrences: PropTypes.number.isRequired,
};
